/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X, Play, Calendar, MapPin } from './Icons';
import './styles/Gallery.css';

import image2 from '../../assets/images/image2.jpg';
import image3 from '../../assets/images/image3.png';
import image4 from '../../assets/images/image4.jpg';
import image5 from '../../assets/images/image5.jpg';
import image6 from '../../assets/images/image6.jpg';
import image7 from '../../assets/images/image7.jpg';
import image8 from '../../assets/images/image8.jfif';
import image9 from '../../assets/images/image9.jfif';
import image10 from '../../assets/images/image10.png';
import image11 from '../../assets/images/image11.jpg';
import image12 from '../../assets/images/image12.png';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const preloadedImages = [
    image2, image3, image4, image5, image6, 
    image7, image8, image9, image10, image11, image12
  ];

  useEffect(() => {
    preloadedImages.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const galleryData = [
    {
      id: 1,
      title: "World One Health Day Celebration 2024",
      category: "events",
      type: "image",
      image: image2,
      date: "November 3, 2024",
      location: "Juba, South Sudan",
      description: "Annual celebration bringing together human, animal, and environmental health sectors to promote the One Health approach.",
      tags: ["One Health", "Collaboration", "Community Engagement"]
    },
    {
      id: 2,
      title: "Emergency Response Training Simulation",
      category: "training",
      type: "image",
      image: image3,
      date: "October 15, 2024",
      location: "Central Equatoria State",
      description: "Hands-on training session for rapid response teams on outbreak investigation and emergency management.",
      tags: ["Training", "Simulation", "Rapid Response"]
    },
    {
      id: 3,
      title: "Field Outbreak Investigation",
      category: "fieldwork",
      type: "image",
      image: image4,
      date: "September 22, 2024",
      location: "Eastern Equatoria State",
      description: "Joint human-animal health team investigating suspected zoonotic disease outbreak in rural communities.",
      tags: ["Outbreak", "Investigation", "Zoonotic Diseases"]
    },
    {
      id: 4,
      title: "Vaccination Campaign Launch",
      category: "services",
      type: "image",
      image: image5,
      date: "August 10, 2024",
      location: "Western Bahr el Ghazal",
      description: "Mass vaccination campaign targeting both human and animal populations in high-risk areas.",
      tags: ["Vaccination", "Prevention", "Public Health"]
    },
    {
      id: 5,
      title: "Laboratory Capacity Building",
      category: "capacity-building",
      type: "image",
      image: image6,
      date: "July 5, 2024",
      location: "National Public Health Laboratory, Juba",
      description: "Training laboratory technicians on advanced diagnostic techniques for emerging pathogens.",
      tags: ["Laboratory", "Diagnostics", "Capacity Building"]
    },
    {
      id: 6,
      title: "Community Awareness Program",
      category: "community",
      type: "image",
      image: image7,
      date: "June 18, 2024",
      location: "Northern Bahr el Ghazal",
      description: "Engaging local communities in disease prevention and health security awareness campaigns.",
      tags: ["Community", "Awareness", "Education"]
    },
    {
      id: 7,
      title: "Cross-Border Collaboration Meeting",
      category: "collaboration",
      type: "image",
      image: image8,
      date: "May 12, 2024",
      location: "Nimule Border Point",
      description: "Regional meeting with neighboring countries to strengthen cross-border disease surveillance.",
      tags: ["Collaboration", "Regional", "Surveillance"]
    },
    {
      id: 8,
      title: "One Health in Action - Documentary",
      category: "multimedia",
      type: "video",
      thumbnail: "/images/one-health-documentary.jpg",
      videoUrl: "https://example.com/one-health-documentary",
      date: "April 20, 2024",
      location: "Various Locations",
      description: "Documentary showcasing the impact of One Health approach in South Sudan's health security.",
      tags: ["Documentary", "One Health", "Impact"]
    },
    {
      id: 9,
      title: "Surveillance System Upgrade",
      category: "technology",
      type: "image",
      image: image9,
      date: "March 8, 2024",
      location: "State Surveillance Centers",
      description: "Installation and training on new digital surveillance systems across state health facilities.",
      tags: ["Technology", "Surveillance", "Digital Health"]
    },
    {
      id: 10,
      title: "Animal Health Vaccination Drive",
      category: "one-health",
      type: "image",
      image: image10,
      date: "February 14, 2024",
      location: "Central Equatoria Communities",
      description: "Integrated animal vaccination campaign to prevent zoonotic disease transmission.",
      tags: ["Animal Health", "Vaccination", "One Health"]
    },
    {
      id: 11,
      title: "Emergency Operations Center Activation",
      category: "emergency",
      type: "image",
      image: image11,
      date: "January 30, 2024",
      location: "National EOC, Juba",
      description: "Activation of Emergency Operations Center during public health emergency response.",
      tags: ["Emergency", "Response", "Coordination"]
    },
    {
      id: 12,
      title: "Research Findings Dissemination",
      category: "research",
      type: "image",
      image: image12,
      date: "January 15, 2024",
      location: "Ministry of Health Complex",
      description: "Sharing research findings on disease patterns and health security interventions.",
      tags: ["Research", "Evidence", "Dissemination"]
    }
  ];

  const categories = [
    { id: 'all', name: 'All Activities', count: galleryData.length },
    { id: 'events', name: 'Events', count: galleryData.filter(item => item.category === 'events').length },
    { id: 'training', name: 'Training', count: galleryData.filter(item => item.category === 'training').length },
    { id: 'fieldwork', name: 'Field Work', count: galleryData.filter(item => item.category === 'fieldwork').length },
    { id: 'services', name: 'Services', count: galleryData.filter(item => item.category === 'services').length },
    { id: 'community', name: 'Community', count: galleryData.filter(item => item.category === 'community').length },
    { id: 'collaboration', name: 'Collaboration', count: galleryData.filter(item => item.category === 'collaboration').length },
    { id: 'research', name: 'Research', count: galleryData.filter(item => item.category === 'research').length },
    { id: 'technology', name: 'Technology', count: galleryData.filter(item => item.category === 'technology').length },
    { id: 'emergency', name: 'Emergency', count: galleryData.filter(item => item.category === 'emergency').length },
    { id: 'one-health', name: 'One Health', count: galleryData.filter(item => item.category === 'one-health').length },
    { id: 'multimedia', name: 'Multimedia', count: galleryData.filter(item => item.category === 'multimedia').length }
  ];

  const filteredData = selectedCategory === 'all' 
    ? galleryData 
    : galleryData.filter(item => item.category === selectedCategory);

  const openLightbox = async (item, index) => {
    setIsLoading(true);
    setSelectedImage(item);
    setCurrentIndex(index);
    await new Promise(resolve => setTimeout(resolve, 100));
    setIsLoading(false);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentIndex(0);
  };

  const goToNext = () => {
    const nextIndex = (currentIndex + 1) % filteredData.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(filteredData[nextIndex]);
  };

  const goToPrevious = () => {
    const prevIndex = (currentIndex - 1 + filteredData.length) % filteredData.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(filteredData[prevIndex]);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') goToNext();
      if (e.key === 'ArrowLeft') goToPrevious();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentIndex]);

  useEffect(() => {
    if (!selectedImage) return;

    let touchStartX = 0;
    let touchEndX = 0;

    const handleTouchStart = (e) => {
      touchStartX = e.changedTouches[0].screenX;
    };

    const handleTouchEnd = (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    };

    const handleSwipe = () => {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          goToNext();
        } else {
          goToPrevious();
        }
      }
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [selectedImage, currentIndex]);

  return (
    <div className="gallery-page" id='gallery-page'>
      <div className="gallery-header">
        <div className="header-content">
          <h1>Department Activities Gallery</h1>
          <p>Showcasing our work in health security, surge capacity development, and One Health approach across South Sudan</p>
        </div>
      </div>

      <section className="gallery-filters">
        <div className="container">
          <h2>Browse by Category</h2>
          <div className="categories-grid">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
                aria-label={`View ${category.name} activities`}
              >
                <span className="category-name">{category.name}</span>
                <span className="category-count">{category.count}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="gallery-grid-section">
        <div className="container">
          <div className="gallery-stats">
            <p>Showing {filteredData.length} of {galleryData.length} activities</p>
          </div>
          
          {filteredData.length === 0 ? (
            <div className="no-results">
              <p>No activities found in this category.</p>
            </div>
          ) : (
            <div className="gallery-grid">
              {filteredData.map((item, index) => (
                <div 
                  key={item.id} 
                  className={`gallery-item ${item.type}`}
                  onClick={() => openLightbox(item, index)}
                  role="button"
                  tabIndex={0}
                  aria-label={`View ${item.title}`}
                  onKeyPress={(e) => e.key === 'Enter' && openLightbox(item, index)}
                >
                  <div className="item-image">
                    <div className="image-placeholder">
                      {item.type === 'video' ? (
                        <>
                          <div className="video-thumbnail">
                            <Play className="play-icon" />
                          </div>
                          <div className="video-badge">Video</div>
                        </>
                      ) : (
                        <div className="photo-badge">
                          <img 
                            src={item.image} 
                            alt={item.title}
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      )}
                    </div>
                    
                    <div className="item-overlay">
                      <div className="overlay-content">
                        <h3>{item.title}</h3>
                        <div className="item-meta">
                          <span className="meta-item">
                            <Calendar className="meta-icon" />
                            {item.date}
                          </span>
                          <span className="meta-item">
                            <MapPin className="meta-icon" />
                            {item.location}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="item-content">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <div className="item-tags">
                      {item.tags.map(tag => (
                        <span key={tag} className="tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {selectedImage && (
        <div className="lightbox">
          <div className="lightbox-backdrop" onClick={closeLightbox}></div>
          <div className="lightbox-content">
            <button 
              className="lightbox-close" 
              onClick={closeLightbox}
              aria-label="Close lightbox"
            >
              <X className="close-icon" />
            </button>
            
            <button 
              className="lightbox-nav lightbox-prev" 
              onClick={goToPrevious}
              aria-label="Previous image"
            >
              <ChevronLeft className="nav-icon" />
            </button>
            
            <button 
              className="lightbox-nav lightbox-next" 
              onClick={goToNext}
              aria-label="Next image"
            >
              <ChevronRight className="nav-icon" />
            </button>

            <div className="lightbox-media">
              {isLoading ? (
                <div className="loading">
                  <div className="loading-spinner"></div>
                </div>
              ) : selectedImage.type === 'video' ? (
                <div className="video-container">
                  <div className="video-placeholder">
                    <Play className="video-play-icon" />
                    <p>Video: {selectedImage.title}</p>
                    <small>Click play to watch</small>
                  </div>
                </div>
              ) : (
                <div className="image-container">
                  <div className="image-placeholder-large">
                    <img 
                      src={selectedImage.image} 
                      alt={selectedImage.title}
                      loading="eager"
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="lightbox-info">
              <h2>{selectedImage.title}</h2>
              <div className="lightbox-meta">
                <span className="meta-item">
                  <Calendar className="meta-icon" />
                  {selectedImage.date}
                </span>
                <span className="meta-item">
                  <MapPin className="meta-icon" />
                  {selectedImage.location}
                </span>
              </div>
              <p>{selectedImage.description}</p>
              <div className="lightbox-tags">
                {selectedImage.tags.map(tag => (
                  <span key={tag} className="tag">{tag}</span>
                ))}
              </div>
            </div>

            <div className="lightbox-counter">
              {currentIndex + 1} / {filteredData.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;